import { H4, H5 } from 'components/headings';
import { Wrapper as TextInputWrapper } from 'components/text-input/text-input.styles';
import { rem } from 'polished';
import styled from 'styled-components';

const LIST_ITEM_INDENT = rem(30);

export const Item = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: -${LIST_ITEM_INDENT};
  padding: ${rem(8)} 0;
  padding-left: ${LIST_ITEM_INDENT};
  border-top: 1px solid transparent;
  border-bottom: 1px solid ${({ theme }) => theme.colors.palette.black};

  button {
    flex-grow: 0;
    align-self: flex-start;
    margin-top: ${rem(-10)};
    margin-bottom: ${rem(-10)};
    margin-left: ${rem(16)};
    padding: ${rem(12)} ${rem(12)} ${rem(8)};
    color: ${({ theme }) => theme.colors.palette.black};
    background-color: transparent;
    border: 0;
    cursor: pointer;

    &:hover,
    &:focus {
      color: ${({ theme }) => theme.colors.palette.redDark};
    }
  }
`;

export const ItemList = styled.ul`
  margin: ${rem(30)} 0 0 ${LIST_ITEM_INDENT};
  padding: 0;

  ${({ theme }) => theme.mediaQueries.medium} {
    margin-top: ${rem(20)};
  }

  li:first-child ${Item} {
    border-top-color: ${({ theme }) => theme.colors.palette.black};
  }
`;

export const ItemForm = styled.form`
  label {
    display: block;
    margin-bottom: ${rem(3)};
  }

  ${({ theme }) => theme.mediaQueries.medium} {
    ${H4} {
      margin-bottom: 1em;
    }
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${TextInputWrapper} {
    width: 100%;
    margin: 0 ${rem(20)} 0 0;
  }

  button {
    min-width: ${rem(120)};
    height: ${rem(40)};
    margin-top: ${rem(10)};
  }

  ${({ theme }) => theme.mediaQueries.medium} {
    flex-direction: row;

    button {
      margin-top: auto;
    }
  }
`;

export const ItemText = styled.span`
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
`;

export const StandaloneTextFieldWrapper = styled.div`
  margin-top: ${rem(24)};
`;

export const TitleMultipleStyles = styled.span`
  color: ${({ theme }) => theme.components.heading.text};
  font-weight: 700;
  font-size: ${rem(24)};
  line-height: 1.15;

  span.inner-span {
    font-weight: 400;
    font-size: ${rem(16)};
  }
`;

export const SpanWrapper = styled.div`
  margin: 0 0 1rem;
  margin-bottom: 1em;
`;

export const SubtitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 1rem;

  ${H5} {
    align-self: flex-end;
    margin-top: 0;
  }

  svg {
    flex-shrink: 0;
    margin-right: 10px;
  }
`;

export const ListWrapper = styled.div`
  margin-left: 22px;
`;
